import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import services from '@/services';
import './index.scss';

const { apis } = services;
let timer: any;

function TabsPage(props: any) {
  const { navsInfo, getActiveObj, pId } = props;
  const [activeTab, setActiveTab] = useState<any>();

  // 滚动
  const toScroll = (ele: any, target: any) => {
    if (Math.abs(target) <= 10) {
      ele.scrollLeft = ele.scrollLeft + target;
    } else {
      if (target < 0) {
        ele.scrollLeft = ele.scrollLeft - 10;
      } else {
        ele.scrollLeft = ele.scrollLeft + 10;
      }
      setTimeout(() => {
        let newTarget;
        if (target < 0) {
          newTarget = target + 10;
        } else {
          newTarget = target - 10;
        }
        toScroll(ele, newTarget);
      }, 16);
    }
  };

  const findTarget = (e: any) => {
    let target = e.target;
    let findTimes = 0;
    while (target && target.className !== "t-item" && findTimes < 5) {
      target = target.parentNode;
    }
    if (target && target.className === "t-item") {
      return target;
    } else {
      return null;
    }
  };

  const clickNav = (v: any, e: any) => {
    setActiveTab(() => v);
    const parent: any = document.getElementById("t-tab");
    const targetNode = findTarget(e);
    if (targetNode) {
      const targetOffsetLeft =
        targetNode.offsetLeft -
        window.innerWidth / 2 +
        targetNode.offsetWidth / 2;
      toScroll(parent, targetOffsetLeft - parent.scrollLeft);
    }

    let extendParams = {
      ...dd.ep,
      providerId: pId,
      activeId: v.pageType,
      aliases: v.aliases,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_lanmu_click",
      {
        ...dd.baseParams,
        area: "top",
      },
      extendParams
    );
  };

  useEffect(() => {
    getActiveObj(activeTab, setActiveTab);
  }, [activeTab]);

  useEffect(() => {
    if (navsInfo?.navs?.length > 0) {
      setActiveTab(navsInfo.navs[0]);
    }
  }, [navsInfo]);

  if (navsInfo.navs && navsInfo.navs.length === 0) {
    return null;
  }

  return navsInfo?.navs?.length > 1 ? (
    <div className="tabsPage">
      <div className="t-tabWrap" id="t-tab">
        {(navsInfo.navs || []).map((v: any) => {
          return (
            <span
              className={
                "t-item" +
                ` ${v.pageType === activeTab?.pageType ? "t-item-active" : ""}`
              }
              onClick={(e) => clickNav(v, e)}
              key={v.pageType}
              style={{
                backgroundImage: `url(${
                  v.background ||
                  "https://x.autoimg.cn/qdty/online/1686732626431.png"
                })`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
              }}
            >
              <span>{v.aliases}</span>
              <span className="line" />
            </span>
          );
        })}
      </div>
    </div>
  ) : null;
}

export default TabsPage;
